// extracted by mini-css-extract-plugin
module.exports = {"error":"ByGenre_error__2fM9L","no-data":"ByGenre_no-data__1pR5Y"};